import { atom } from 'recoil';
import { NotificationHistoryType } from '../../hooks';

export const withNotificationHistory = atom({
  key: 'notifications.notificationHistory',
  default: [] as NotificationHistoryType[],
  dangerouslyAllowMutability: true
});
